import _ from 'lodash';
import { ActionReducerMapBuilder } from '@reduxjs/toolkit';

import * as actions from '../actions';
import { PubnubState } from '..';
import { PB_CHANNELS, PB_OCCUPANCY_CHANNELS } from '../constants';

export const getActiveUsersBuilder = (builder: ActionReducerMapBuilder<PubnubState>) => {
  return builder
    .addCase(actions.getActiveUsers.pending, (state) => {
      state.isBusy = true;
    })
    .addCase(actions.getActiveUsers.fulfilled, (state, action) => {
      const anonymousUsersChannel = _.find(action.payload.channels, (ch) =>
        ch.name.includes(`${PB_CHANNELS.OCCUPANCY}.${PB_OCCUPANCY_CHANNELS.LISTENERS}`),
      );
      const signedUsersChannel = _.find(action.payload.channels, (ch) =>
        ch.name.includes(`${PB_CHANNELS.OCCUPANCY}.${PB_OCCUPANCY_CHANNELS.AUTH}`),
      );

      let listenersOccupancy = anonymousUsersChannel?.occupancy || state.occupancy.anonymous;
      let authUsersOccupancy = signedUsersChannel?.occupancy || state.occupancy.signedIn;

      if (signedUsersChannel === undefined) {
        authUsersOccupancy = 0;
      }

      if (anonymousUsersChannel === undefined) {
        listenersOccupancy = 0;
      }

      state.occupancy.anonymous = listenersOccupancy;
      state.occupancy.signedIn = authUsersOccupancy;
      state.isBusy = false;
    })
    .addCase(actions.getActiveUsers.rejected, (state) => {
      state.isBusy = false;
    });
};
